var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.3121 0.386719H7.7C3.104 0.386719 0.5 2.99072 0.5 7.58671V20.1868C0.5 24.7827 3.104 27.3867 7.7 27.3867H20.3121C24.908 27.3867 27.5 24.7827 27.5 20.1868V7.58671C27.5 2.99072 24.908 0.386719 20.3121 0.386719Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.567 10.134C20.6352 10.134 21.5011 9.268 21.5011 8.19979C21.5011 7.13158 20.6352 6.26562 19.567 6.26562C18.4988 6.26562 17.6328 7.13158 17.6328 8.19979C17.6328 9.268 18.4988 10.134 19.567 10.134Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.5662 11.013C18.0119 11.013 16.7529 9.754 16.7529 8.19964C16.7529 7.6862 16.9006 7.20794 17.1468 6.79297H10.4229C8.48172 6.79297 6.90625 8.3614 6.90625 10.2956V14.5015V15.2048C6.90625 17.139 8.48172 18.7074 10.4229 18.7074H11.4779C11.6678 18.7074 11.921 18.834 12.0406 18.9888L13.0956 20.3884C13.5598 21.0073 14.3194 21.0073 14.7836 20.3884L15.8386 18.9888C15.9722 18.8129 16.1832 18.7074 16.4012 18.7074H17.4562C19.3974 18.7074 20.9729 17.139 20.9729 15.2048V10.6191C20.5579 10.8653 20.0797 11.013 19.5662 11.013Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9377 13.8285C13.5438 13.8285 13.2344 13.512 13.2344 13.1252C13.2344 12.7384 13.5509 12.4219 13.9377 12.4219C14.3245 12.4219 14.641 12.7384 14.641 13.1252C14.641 13.512 14.3316 13.8285 13.9377 13.8285Z",
    fill: "#CE2600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7502 13.8285C16.3563 13.8285 16.0469 13.512 16.0469 13.1252C16.0469 12.7384 16.3634 12.4219 16.7502 12.4219C17.137 12.4219 17.4535 12.7384 17.4535 13.1252C17.4535 13.512 17.1441 13.8285 16.7502 13.8285Z",
    fill: "#CE2600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1252 13.8285C10.7313 13.8285 10.4219 13.512 10.4219 13.1252C10.4219 12.7384 10.7384 12.4219 11.1252 12.4219C11.512 12.4219 11.8285 12.7384 11.8285 13.1252C11.8285 13.512 11.5191 13.8285 11.1252 13.8285Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.4a79e20b6dd5f016e0935b0724090483.svg";
export { ForwardRef as ReactComponent };